export const NOTIFICATION = {
  GET_NOTIFICATION_REQUEST: 'GET_NOTIFICATION_REQUEST',
  GET_NOTIFICATION_SUCCESS: 'GET_NOTIFICATION_SUCCESS',
  CHANGE_IS_READ: 'CHANGE_IS_READ',
  SET_OPEN_NOTIFICATION: 'SET_OPEN_NOTIFICATION',
  SET_ZTL_NOTIFICATION: 'SET_ZTL_NOTIFICATION',
};
